import React from "react";
import { inject, observer } from "mobx-react";
import { Loading } from "../Components/Loading";
import { appConfig } from "../config";
import { CheckListItem } from "../Components/Checklist";
import { ImageUpload } from "../Components/ImageUpload";
import LightboxImage from "../Components/Lightbox";
import { toJS } from "mobx";

@inject("AppStore")
@observer
class ConfigurationCheck extends React.Component {
  store = this.props.AppStore;

  state = {
    lightbox: false,
    lightboxIndex: 0,
  };

  openLightbox(index) {
    this.setState({ lightbox: true, lightboxIndex: index });
  }

  async componentDidMount() {
    await this.store.loadConfig();

    const { user } = this.store;
    if (!user) window.location.href = "/";

    const { id } = this.props.match.params;

    await this.store.getServiceDetail(id);
    this.store.service.number = id;
  }

  render() {
    const { page } = this.store;

    if (page.loading) return <Loading />;

    const data = this.store.service_data;

    return (
      <div className="app">
        <div className="header">
          <div className="logo-wrapper">
            <a
              href={`${appConfig.locale.url}/${this.store.page.lang}`}
              style={{
                display: "flex",
                alignItems: "center",
                color: "#000",
                textDecoration: "none",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {this.store.configuration && this.store.configuration.logo && (
                <img
                  alt="logo"
                  src={appConfig.locale.api + this.store.configuration.logo.url}
                  className="logo"
                />
              )}
              <span>
                {this.store.location && this.store.location.displayname}
              </span>
            </a>
          </div>
          {this.store.user ? (
            <div className="header-user">
              <span>{this.store.user.user.fullname} -&nbsp;</span>
              <a onClick={this.store.logout}>LOGOUT</a>
            </div>
          ) : (
            <div className="header-user">
              <a href={`/account`}>Account</a>
            </div>
          )}
        </div>
        <div style={{ padding: "0 25px" }}>
          <div>
            <h2>KONFIGURASYON KONTROL FORMU</h2>
          </div>

          <div>
            <h3>Müşteri Bilgileri</h3>
          </div>
          <div className="form-build">
            <div className="form-item">
              <label>Konfigurasyon ID</label>
              <input
                disabled
                type="text"
                name="config_id"
                value={`${data.order_number}`}
              />
            </div>
            <div className="form-item">
              <label>Ad Soyad</label>
              <input
                disabled
                type="text"
                name="fullname"
                value={`${data.firstname} ${data.lastname}`}
              />
            </div>
            <div className="form-item">
              <label>Telefon</label>
              <input disabled type="text" name="phone" value={data.phone} />
            </div>
            <div className="form-item">
              <label>Email</label>
              <input disabled type="text" name="email" value={data.email} />
            </div>
          </div>
          <div>
            <h3>Tekne Bilgileri</h3>
          </div>
          <div className="form-build">
            <div className="form-item">
              <label>Model</label>
              <input
                disabled
                type="text"
                name="model"
                value={data.model.name}
              />
            </div>
            <div className="form-item">
              <label>Slot No</label>
              <input
                disabled
                type="text"
                name="slot_number"
                value={data.slot_number}
              />
            </div>
            <div className="form-item">
              <label>Üretim Yılı</label>
              <input
                disabled
                type="text"
                name="built_year"
                value={data.built_year}
              />
            </div>

            <div className="form-item">
              <label>Model Yılı</label>
              <input
                disabled
                type="text"
                name="model_year"
                value={data.model_year}
              />
            </div>
            <div className="form-item">
              <label>Bayrak</label>
              <input disabled type="text" name="flag" value={data.flag} />
            </div>
            <div className="form-item">
              <label>Notlar</label>
              <pre
                className="textarea"
                dangerouslySetInnerHTML={{ __html: data.factory_notes }}
              ></pre>
            </div>
          </div>

          <div>
            <h3>Kontroller</h3>
          </div>
          <div>
            <table className="checklist" style={{ width: "100%" }}>
              <tbody>
                {toJS(this.store.service_data.raw).map((item, i) => (
                  <CheckListItem
                    key={i}
                    object={this.store.service_data.raw[i]}
                    field="value"
                    text={`${item.sku} - ${item.title}`}
                  />
                ))}
              </tbody>
            </table>
          </div>

          <div className="attachments">
            <h3>Ekler</h3>
            {this.store.configuration_data &&
              this.store.configuration_data.images && (
                <React.Fragment>
                  {this.state.lightbox && (
                    <LightboxImage
                      images={this.store.configuration_data.images.map(
                        (i) => `${appConfig.api}${i.url}`
                      )}
                      photoIndex={this.state.lightboxIndex}
                      onCloseRequest={() => this.setState({ lightbox: false })}
                    />
                  )}

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                    }}
                  >
                    {this.store.configuration_data.images.map((item, i) => (
                      <div key={i}>
                        <div
                          onClick={() => this.openLightbox(i)}
                          style={{ display: "block", padding: 10 }}
                        >
                          <img
                            src={`${appConfig.api}${item.url}`}
                            alt=""
                            width="100%"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </React.Fragment>
              )}
          </div>

          <div>
            <ImageUpload
              onChange={(v) => (this.store.configuration_gallery = v)}
            />
          </div>

          <div style={{ margin: "30px 0" }}>
            <button
              onClick={(e) => this.store.onConfigurationCheckSave()}
              style={{
                cursor: "pointer",
                appearance: "none",
                border: "none",
                background: "green",
                color: "#fff",
                width: "100%",
                padding: "10px 160px",
                display: "block",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default ConfigurationCheck;
